import Repository from "../Repository";

const resource = "/insertionorders";
export default {
    get(){
        return Repository.get(`${resource}`);
    },
    getInsetionOrder(insertionOrderId){
        return Repository.get(`${resource}/${insertionOrderId}`);
    },
    createInsertionOrder(json){
        return Repository.post(`${resource}`,json);
    },
    updateInsertionOrder(insertionOrderId,json){
        return Repository.put(`${resource}/${insertionOrderId}`,json);
    },
    deleteInsertionOrder(insertionOrderId){
        return Repository.delete(`${resource}/${insertionOrderId}`);
    }
}